(function () {
  class ReelSpinnerVisualSCS extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      dynamicSpinner
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp,
        dynamicSpinner
      );

      this._xSymbolOverlays = [];
      this._x2Overlays = [];
      this._x3Overlays = [];
      this._x5Overlays = [];

      this._scalingOverlays = [];
      this._scalingOverlayPool = [];
      this._scalingOverlayCount = 0;

      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
    }

    onLayoutChange() {
      // Complete any active scaling animations immediately
      for (let i = 0; i < this._scalingOverlays.length; i++) {
        const overlay = this._scalingOverlays[i];
        gsap.killTweensOf(overlay);
        overlay.visible = false;
        this._scalingOverlayPool.push(overlay);
      }
      this._scalingOverlays = [];

      for (let i = 0; i < this._symbolGfxObjects.length; i++) {
        this._symbolGfxObjects[i].visible = true;
      }
    }

    getScalingOverlay() {
      const overlayContainer = gameController.overlayDisplay._overlayParent;

      if (this._scalingOverlayPool.length > 0) {
        return this._scalingOverlayPool.pop();
      }

      const reelIndex = gameData.reels.indexOf(this);
      const overlay = resourceManager.createObject(
        'movie',
        'scalingOverlay_r' + reelIndex + '_' + this._scalingOverlayCount,
        overlayContainer.name,
        {
          definition: 'staticSymbols',
          anchor: 0.5,
        }
      );
      this._scalingOverlayCount++;
      overlay.visible = false;
      return overlay;
    }

    returnScalingOverlay(overlay) {
      overlay.visible = false;
      this._scalingOverlayPool.push(overlay);
    }

    scaleSymbol(index, duration, delay = 0) {
      const symbol = this._symbolGfxObjects[index];
      const slotContainer = resourceManager.get('slotContainer');

      const reelIndex = gameData.reels.indexOf(this);
      const symbolPos = helpers.getSymbolPos(reelIndex, index);
      const symbolData = this._reelSpinnerData.getSymbolData();
      const symbolId = symbolData[index].symId;

      // Get/create overlay sprite
      const overlay = this.getScalingOverlay();
      overlay.gotoAndStop(symbolId);
      overlay.position.set(symbolPos.x, symbolPos.y);
      overlay.scale.set(slotContainer.scale.x);
      overlay.visible = true;
      this._scalingOverlays.push(overlay);

      symbol.visible = false;

      this._multiOverlay = undefined;

      if (symbolId === 11) {
        //this._multiOverlay = this._x2Overlays[index];
        //overlay.addChild(this._multiOverlay);
      }
      if (symbolId === 12) {
        //this._multiOverlay = this._x3Overlays[index];
        //overlay.addChild(this._multiOverlay);
      }
      if (symbolId === 13) {
        //this._multiOverlay = this._x5Overlays[index];
        //overlay.addChild(this._multiOverlay);
      }

      const baseScale = slotContainer.scale.x;
      gsap.to(overlay, {
        pixi: { scale: baseScale * 1.1 },
        duration: duration / 3,
        ease: 'power1.out',
        yoyo: true,
        repeat: 1,
        delay,
        onComplete: () => {
          // Show original, hide overlay
          symbol.visible = true;
          overlay.visible = false;

          if (this._multiOverlay) {
            let gfxObject = this._symbolGfxObjects[index];
            gfxObject.symbol.childContainer.addChild(this._multiOverlay);
          }

          // Return to pool
          const idx = this._scalingOverlays.indexOf(overlay);
          if (idx > -1) this._scalingOverlays.splice(idx, 1);
          this.returnScalingOverlay(overlay);
        },
      });
    }

    createSymbolOverlays() {
      let totalAppertureSize = this.getReelSpinnerData().getTotalAppertureSize();

      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let xSymOverlay = resourceManager.createObject('sprite', 'xSymOverlay', gfxObject.symbol.childContainer, {
          fileName: 'slots/symbols/X/X.png',
          anchor: 0.5,
          x: gameController.xSymbolPositionOffset.x,
          y: gameController.xSymbolPositionOffset.y,
          scale: gameController.xSymbolScale,
        });
        xSymOverlay.visible = false;
        this._xSymbolOverlays.push(xSymOverlay);

        let x2Overlay = resourceManager.createObject('sprite', 'x2Overlay', gfxObject.symbol.childContainer, {
          fileName: 'slots/symbols/Mega Wild/Multipliers/MW_X2.png',
          anchor: 0.5,
          x: 0,
          y: 42,
        });
        x2Overlay.visible = false;
        this._x2Overlays.push(x2Overlay);

        let x3Overlay = resourceManager.createObject('sprite', 'x3Overlay', gfxObject.symbol.childContainer, {
          fileName: 'slots/symbols/Mega Wild/Multipliers/MW_X3.png',
          anchor: 0.5,
          x: 0,
          y: 42,
        });
        x3Overlay.visible = false;
        this._x3Overlays.push(x3Overlay);

        let x5Overlay = resourceManager.createObject('sprite', 'x5Overlay', gfxObject.symbol.childContainer, {
          fileName: 'slots/symbols/Mega Wild/Multipliers/MW_X5.png',
          anchor: 0.5,
          x: 0,
          y: 42,
        });
        x5Overlay.visible = false;
        this._x5Overlays.push(x5Overlay);
      }
    }

    startDynamicSpin() {
      super.startDynamicSpin();
    }

    updateSymbolOverlays(ids, overlays) {
      super.updateSymbolOverlays(ids, overlays);

      for (let i = 0; i < ids.length; i++) {
        let symId = ids[i];

        if (symId >= 14 && symId <= 21) {
          this._xSymbolOverlays[i].visible = true;
        } else {
          this._xSymbolOverlays[i].visible = false;
        }

        if (symId === 11) {
          this._x2Overlays[i].visible = true;
        } else {
          this._x2Overlays[i].visible = false;
        }

        if (symId === 12) {
          this._x3Overlays[i].visible = true;
        } else {
          this._x3Overlays[i].visible = false;
        }

        if (symId === 13) {
          this._x5Overlays[i].visible = true;
        } else {
          this._x5Overlays[i].visible = false;
        }
      }
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);
    }

    getMegaWildOverlay(index, symId) {
      if (symId === 11) {
        return this._x2Overlays[index];
      } else if (symId === 12) {
        return this._x3Overlays[index];
      } else if (symId === 13) {
        return this._x5Overlays[index];
      } else {
        return undefined;
      }
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisualSCS(
      json.ID,
      json.ID + ' container',
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp,
      gameController.dynamicSpinner
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    reelSpinnerVisual.createSymbolOverlays();
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType('ReelSpinnerVisualSCS', create, initialise, getRequiredFiles);
})();
